var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoirHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4996 14.77C38.5056 17.3346 37.4682 19.8017 35.6051 21.6533C31.3333 25.8717 27.1893 30.27 22.7601 34.3333C21.7433 35.25 20.1316 35.2167 19.1603 34.2583L6.39406 21.655C2.53531 17.845 2.53531 11.695 6.39406 7.88667C7.30606 6.975 8.40295 6.2492 9.61825 5.75329C10.8335 5.25737 12.1419 5.00167 13.4641 5.00167C14.7862 5.00167 16.0946 5.25737 17.3099 5.75329C18.5252 6.2492 19.6221 6.975 20.5341 7.88667L20.9996 8.34333L21.4633 7.88667C22.3764 6.97624 23.4735 6.25116 24.6885 5.75507C25.9035 5.25898 27.2114 5.00214 28.5333 5C31.1933 5 33.7361 6.04 35.6033 7.88667C37.4671 9.73807 38.5051 12.2052 38.4996 14.77Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirHeart);
export default __webpack_public_path__ + "static/media/iconoir_heart.4f639c8830427aa02bd319b936688813.svg";
export { ForwardRef as ReactComponent };